import { render } from "./FeeStructure.vue?vue&type=template&id=a57b009a&scoped=true"
import script from "./FeeStructure.vue?vue&type=script&lang=js"
export * from "./FeeStructure.vue?vue&type=script&lang=js"

import "./FeeStructure.vue?vue&type=style&index=0&id=a57b009a&lang=scss&scoped=true"

import exportComponent from "C:\\GoogleDrive\\Projects\\Vue\\_published\\ksaien\\ksaien\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a57b009a"]])

export default __exports__